// Initialise Digital Data Object.
export const _satellite: any = {};
export const digitalData: any = {};
digitalData.page = digitalData.page || {}; 				// Information of the page access by consumer
digitalData.product = digitalData.product || {}; 				// Information of product accees or purchesed by consumer.
digitalData.consumer = digitalData.consumer || {}; 				// Information about the consumer
digitalData.transaction = digitalData.transaction || {};				// Information of Order or application made by consumer.
digitalData.event = digitalData.event || {};				// ClickStream events made by consumer.
digitalData.system = digitalData.system || {};              //contain the information which provided by the system not fill by user.

// To be invoked on every page load. Initialises page section of data layer object.
export function initiPageInfo(siteSection, siteSubSection, server, productId, productName, consumerType, applicationKey, applicantKey, nextTaskKey, sourceChannel,mobileno,guestId,customerId,userType,applicantId) {
        try {
        digitalData.consumer = digitalData.consumer || {},
        digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.contact = digitalData.consumer.contact || {}
            digitalData.version = "v1.0",
            digitalData.page.siteSection = siteSection || "",
            digitalData.page.siteSubSection = siteSubSection || "",
            digitalData.page.server = server || "",
            digitalData.product.productId = productId || "",
            digitalData.consumer.type = consumerType || ""
             digitalData.product.productName = productName || "",
            digitalData.consumer.applicationKey = applicationKey || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventId = "pageInitialization",
            digitalData.event.eventContext.sourceChannel = sourceChannel || "",
            digitalData.consumer.guestId=guestId||"",                 //updated guest id
            digitalData.consumer.customerId=customerId||"",           //updated  customer id
            digitalData.consumer.userType=userType||"",               //updated user type
            digitalData.consumer.applicantId=applicantId||"",           //updated applicant id
            digitalData.consumer.contact.mobileNo=mobileno==undefined?"": mobileno, 
            digitalData.event.eventContext.ctaText = "",
            digitalData.event.eventContext.componentName = "" 
        callStatellite("omnichannel-init-pageload");
        
    }
    catch (err) { }
}

//this function will fire when user click on any cta 
export function allctaInteraction(componentName, ctaText, productId, sourceChannel,mobileno,guestId,customerId,userType,applicantId) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.product = digitalData.product || {};
        digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.contact = digitalData.consumer.contact || {}
            digitalData.event.eventContext.ctaText = "" || ctaText,
            digitalData.event.eventContext.componentName = componentName || "",
            digitalData.product.productId = productId || "",
            digitalData.event.eventId = "all cta interaction",
            digitalData.event.eventContext.sourceChannel = sourceChannel || "",
            digitalData.consumer.contact.mobileNo=mobileno==undefined?"": mobileno, 
            digitalData.consumer.guestId=guestId||"",                 //updated guest id
            digitalData.consumer.customerId=customerId||"",           //updated  customer id
            digitalData.consumer.userType=userType||"",               //updated user type
            digitalData.consumer.applicantId=applicantId||"",
            callStatellite('all-cta-interaction');
    } catch (er) { }
}
export function bankaccountselectionProceed(applicationKey, applicantKey, nextTaskKey, productId, sourceChannel, ctaText,mobileno,guestId,customerId,userType,applicantId) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {}
            digitalData.consumer.applicationKey = applicationKey || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventContext.ctaText = ctaText || "",
            digitalData.event.eventId = "bank account selection proceed",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.productId = productId || sessionStorage.getItem("productid") || sessionStorage.get('occupationIdentifier') || "",
            digitalData.consumer.guestId=guestId||"",                 //updated guest id
            digitalData.consumer.customerId=customerId||"",           //updated  customer id
            digitalData.consumer.userType=userType||"",               //updated user type
            digitalData.consumer.applicantId=applicantId||"",         //updated applicant id
            digitalData.consumer.contact.mobileNo=mobileno==undefined?"": mobileno, 
            callStatellite("bank-account-selection-proceed");
    }
    catch (err) { }
}

// common function for _satellite
export const callStatellite = (eventName) => {
    try {
        setTimeout(() => {
            _satellite.track(eventName);
        }, 0);
    } catch (error) { }

};